import { gsap, ScrollTrigger, SplitText } from './gsap';

const panelPinning = () => {
  const panels = gsap.utils.toArray('.panel');
  const defaults = { ease: 'expo.out', duration: 1 };

  if (panels.length > 0) {
    panels.forEach((panel, i) => {
      const panelTitle = panel.querySelector('.panel-title');
      const panelText = panel.querySelector('.panel-text');
      const panelImg = panel.querySelector('.panel-img');

      const titleWords = new SplitText(panelTitle, {
        type: 'words',
        wordsClass: 'split'
      });

      const titleLetters = new SplitText(titleWords.words, {
        type: 'chars',
        charsClass: 'chars'
      });

      gsap.set(titleLetters.chars, { yPercent: 100, skewY: 5, visibility: 'hidden' });
      gsap.set(panelText, { yPercent: 100, autoAlpha: 0 });
      gsap.set(panelImg, { clipPath: 'inset(0% 0% 100%)', scaleY: 0.9 });

      const tl = gsap.timeline({ paused: true });
      tl.to(titleLetters.chars, {
        ...defaults,
        yPercent: 0,
        visibility: 'visible',
        skewY: 0,
        stagger: 0.05,
      })
        .to(panelText, {
          ...defaults,
          yPercent: 0,
          autoAlpha: 1,
        }, '<25%')
        .to(panelImg, {
          duration: 1,
          clipPath: 'inset(0% 0% 0%)',
          scaleY: 1
        }, '<25%');

      ScrollTrigger.create({
        trigger: panel,
        start: 'top 60%',
        onEnter: () => tl.play()
      });

      ScrollTrigger.create({
        trigger: panel,
        start: 'top bottom',
        onLeaveBack: () => tl.pause(0)
      });

      ScrollTrigger.create({
        trigger: panel,
        start: () => (panel.offsetHeight < window.innerHeight ? 'top -1px' : 'bottom bottom'),
        pin: i === panels.length - 1 ? false : true,
        pinSpacing: false,
      });
    });
  }
};

export default panelPinning;
